/**
 * ADR-0185 Addendum 5 — the Next-up TAB's face for the machine-scheduling
 * template: the rail moved WHOLE (subtitle, headers, hover cards) off the
 * board, owner-ruled ("Next up is not the headliner"). A read-only face of
 * the STANDING plan; clicking a machine row opens the Board tab with that
 * machine's lane expanded (the focus key is the machine name — minted here,
 * interpreted by the board view, opaque to the shell).
 */
import { EmptyState } from "../../../States.js";
import type { NextUpViewProps } from "../../viewRegistry.js";
import { NextUpRail } from "./NextUpRail.js";
import { measuredCountsOf } from "./laneMath.js";

export function NextUpFace(props: NextUpViewProps) {
  const { view } = props;
  if (!view) {
    return (
      <div className="card">
        <EmptyState title="No plan to draw yet." />
      </div>
    );
  }
  return (
    <div className="card">
      <strong>Next up</strong>
      <div className="help" style={{ marginTop: 2 }}>
        For each machine: what's running now, what the plan runs next, and what that changeover costs.
        Click a machine to see its lane on the board.
      </div>
      <NextUpRail
        lanes={view.lanes}
        measuredCounts={measuredCountsOf(view.changeover_classes)}
        selectedMachine={null}
        onSelect={(machine) => {
          if (machine) props.onOpenBoard(machine);
        }}
      />
    </div>
  );
}
